import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.AttachInvoice.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.AttachInvoice.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.AttachInvoice.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem/AttachInvoice/:claimJobPaymentItemId/:claimInvoiceId';
export default async function attachInvoiceToClaimJobPaymentItem(
  claimJobPaymentItemId: number,
  claimInvoiceId: number
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { claimJobPaymentItemId, claimInvoiceId }),
    body: {},
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
